<template>
  <SysDialog
    v-model="dialog_ativo"
    ocultar-acoes
    :largura="550"
  >
    <template #titulo>
      <div class="d-flex w-full py-2">
        <div class="d-flex w-full align-center justify-center text-center">
          <v-icon color="black" size="25">mdi-account-tie-voice</v-icon>
          <span class="font-20 pl-2 text-uppercase">Você faz a diferença!</span>
        </div>

        <v-btn icon @click="dialog_ativo = !dialog_ativo">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <div class="pt-2 pb-6 font-14 mt-n1 px-5">
      <p class="ma-0 mb-2 text-black">
        Queremos ouvir você! Responda nossa pesquisa rápida e ajude-nos a criar a melhor experiência possível no Systock.
      </p>

      <p class="ma-0 mt-5 text-black">
        Agradecemos sua contribuição!
      </p>

      <div class="mt-8 bg-systock-1 cursor-pointer text-white bra-5 text-center pa-2" @click="clicouPraResponder">
        Responder pesquisa
      </div>
    </div>
  </SysDialog>
</template>

<script setup>
import {onMounted, ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";

const dialog_ativo = ref(false);

onMounted(() => {
  if (localStorage.atualizacao_auto === 'S') {
    return;
  }

  verificarNovaRespostaNps()
});

function verificarNovaRespostaNps() {
  api.get('nps/verificacao-nova-resposta')
    .then(resposta => {
      if (resposta.data.ativar_nova_resposta) {
        dialog_ativo.value = true;
      }
    })
}

function clicouPraResponder() {
  window.open('https://principled-sunscreen-136.notion.site/1820f950600b80b5a6bfff892c281f33?pvs=105', "_blank");
  dialog_ativo.value = false;

  api.post('nps')
    .then(() => {

    })
}
</script>
